<template>
  <v-container background pa-3 fluid>
    <v-layout
      row
      wrap
      pa-3
      style="background-color: #fff; margin-top: 5px; border-radius: 5px"
    >
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 style="margin-top: 15px">
            <p style="font-size: 20px; padding: 10px 0">{{ $t("PNDForm") }}</p>
          </v-flex>
          <v-flex lg2 md4 xs12 px-1>
            <v-select
              required
              :items="branch_items"
              :label="$t('branch')"
              item-text="name"
              item-value="code"
              v-model="branch"
              hide-details
            />
          </v-flex>
          <v-flex lg2 md4 xs12 px-1>
            <v-text-field
              :label="$t('fromdate')"
              type="date"
              v-model="from_date"
              hide-details
            />
          </v-flex>
          <v-flex lg2 md4 xs12 px-1>
            <v-text-field
              :label="$t('todate')"
              type="date"
              v-model="to_date"
              hide-details
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap style="margin-top: 15px">
          <v-flex lg2 md2 sm12 xs12 px-1>
            <v-btn block color="success" @click="process()">
              <v-icon class="pr-2" size="16">fa-file-download</v-icon>
              <span>{{ $t("Loaddata") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout row wrap style="padding-top: 15px" v-if="tabledata == true">
          <v-layout row wrap align-center v-if="json.details.length == 0">
            <v-flex xs12 >
              <v-card justify-center >
                <v-card-title primary-title class="justify-center">
                  <span style="font-size: 16px">
                ไม่มีข้อมูล
              </span>
                </v-card-title>
              </v-card> 
              
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="json.details.length > 0">
            <v-btn
              dark
              color="blue-grey darken-2"
              v-if="buttonlist == 1"
              @click="checkbutton(0, 'display')"
            >
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn
              dark
              v-else
              color="light-blue accent-4"
              @click="checkbutton(0, 'display')"
            >
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn
              dark
              color="blue-grey darken-2"
              v-if="buttonlist == 0"
              @click="checkbutton(1, 'display')"
            >
              <v-icon dark>fa-table</v-icon>
            </v-btn>
            <v-btn
              dark
              v-else
              color="light-blue accent-4"
              @click="checkbutton(1, 'display')"
            >
              <v-icon dark>fa-table</v-icon>
            </v-btn>
          </v-layout>
          <!-- List -->
          <v-flex md12 sm12 xs12>
            <v-layout
              row
              wrap
              v-if="!showLoading && json.details.length > 0"
            >
              <v-layout row wrap v-if="buttonlist == 0">
                <v-flex xs12>
                  <v-layout row wrap style="margin-top: 5px; margin-left: 10px">
                    <v-flex lg4 md6 sm6 xs12>
                      <v-layout row wrap>
                        <v-btn
                          block
                          color="primary"
                          style="margin-right: 5px"
                          @click="viewpdf()"
                        >
                          <v-icon class="pr-2" size="16">fa-file-pdf</v-icon>
                          <span>{{ $t("Exportpdf") }}</span>
                        </v-btn>
                        <v-btn block color="primary" @click="viewAttach1()">
                          <v-icon class="pr-2" size="16">fa-file-pdf</v-icon>
                          <span>{{ $t("AttachmentPND") }}</span>
                        </v-btn>
                      </v-layout>
                    </v-flex>
                    <v-flex
                      lg8
                      md6
                      sm6
                      xs12
                      text-lg-right
                      text-md-right
                      text-sm-right
                      text-xs-right
                      style="font-size: 16px"
                    >
                      <p>
                        {{ $t("Page") + " : " }}{{ pageActive }}/{{
                          newarrayemp.length
                        }}
                      </p>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-container
                  fluid
                  pt-3
                  style="
                    border-right: 0px;
                    border-left: 0px;
                    padding-right: 0px;
                    padding-bottom: 0px;
                    padding-left: 0px;
                  "
                >
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 class="hidden-sm-and-up">
                      <!-- ไม่แสดงขนาดกลางและขนาดใหญ๋ -->
                      <v-card
                        v-for="(item, i) in arraydetails"
                        :key="i"
                        style="padding: 10px"
                      >
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm12 xs12>
                            <v-layout row wrap>
                              <v-flex
                                lg12
                                md12
                                sm12
                                xs12
                                class="hidden-xs-only content"
                              >
                                <span>{{ item.emp_name }}</span>
                                <span class="coco-list-label-text content"
                                  >({{ item.emp_code }})</span
                                >
                              </v-flex>
                              <v-flex
                                lg12
                                md12
                                sm12
                                xs12
                                class="hidden-sm-and-up"
                              >
                                <span>{{ item.emp_name }}</span>
                                <span class="coco-list-label-text content"
                                  >({{ item.emp_code }})</span
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md12 sm12 xs12 text-lg-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span class="coco-list-label-text">
                                  {{ $t("Taxpaymentdate") + " : " }}
                                  <span>{{
                                    selectedformatDates(item.payDate)
                                  }}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm12 xs12></v-flex>
                          <v-flex lg2 md12 sm12 xs12 text-lg-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color: #00000080">
                                  {{ $t("Salary") + " : " }}
                                  <span class="text-salary"
                                    >{{ formatNumber(item.earning) }} &nbsp;{{
                                      $t("baht")
                                    }}</span
                                  >
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm12 xs12>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex
                                    lg6
                                    md6
                                    sm6
                                    xs6
                                    class="hidden-xs-only content"
                                  >
                                    <span class="coco-list-label-text">
                                      {{ $t("TaxID") + " : " }}
                                      <span>{{ item.id_card }}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 class="hidden-sm-and-up">
                                    <span class="coco-list-label-text">
                                      {{ $t("TaxID") + " : " }}
                                      <span>{{ item.id_card }}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md12 sm12 xs12 text-lg-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color: #00000080">
                                  {{ $t("Tax") + " : " }}
                                  <span class="text-tax">{{
                                    formatNumber(item.tax_pay)
                                  }}</span>
                                  &nbsp;{{ $t("baht") }}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <v-flex md12 sm12 xs12 class="hidden-xs-only content">
                      <v-card
                        v-for="(item, i) in arraydetails"
                        :key="i"
                        style="padding: 10px"
                      >
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm9 xs9>
                            <v-layout row wrap>
                              <v-flex
                                lg12
                                md12
                                sm12
                                xs12
                                class="hidden-xs-only content"
                              >
                                <span>{{ item.emp_name }}</span>
                                <span class="coco-list-label-text content"
                                  >({{ item.emp_code }})</span
                                >
                              </v-flex>
                              <v-flex
                                lg12
                                md12
                                sm12
                                xs12
                                class="hidden-sm-and-up"
                              >
                                <span>{{ item.emp_name }}</span>
                                <span class="coco-list-label-text content"
                                  >({{ item.emp_code }})</span
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex
                            lg2
                            md3
                            sm3
                            xs3
                            text-lg-right
                            text-md-right
                            text-sm-right
                          >
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span class="coco-list-label-text">
                                  {{ $t("Taxpaymentdate") + " : " }}
                                  <span>{{
                                    selectedformatDates(item.payDate)
                                  }}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm9 xs6></v-flex>
                          <v-flex
                            lg2
                            md3
                            sm3
                            xs3
                            text-lg-right
                            text-md-right
                            text-sm-right
                          >
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color: #00000080">
                                  {{ $t("Salary") + " : " }}
                                  <span class="text-salary"
                                    >{{ formatNumber(item.earning) }} &nbsp;{{
                                      $t("baht")
                                    }}</span
                                  >
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm9 xs9>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex
                                    lg6
                                    md6
                                    sm6
                                    xs6
                                    class="hidden-xs-only content"
                                  >
                                    <span class="coco-list-label-text">
                                      {{ $t("TaxID") + " : " }}
                                      <span>{{ item.id_card }}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 class="hidden-sm-and-up">
                                    <span class="coco-list-label-text">
                                      {{ $t("TaxID") + " : " }}
                                      <span>{{ item.id_card }}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex
                            lg2
                            md3
                            sm3
                            xs3
                            text-lg-right
                            text-md-right
                            text-sm-right
                          >
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color: #00000080">
                                  {{ $t("Tax") + " : " }}
                                  <span class="text-tax">{{
                                    formatNumber(item.tax_pay)
                                  }}</span>
                                  &nbsp;{{ $t("baht") }}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
                <!-- ปุ่มกดเปลี่ยนหน้า -->
                <v-layout
                  row
                  wrap
                  align-center
                  justify-center
                  style="margin-top: 20px"
                >
                  <v-pagination
                    v-model="pageActive"
                    :length="totalPages"
                    circle
                    @input="getdataList(pageActive)"
                  ></v-pagination>
                </v-layout>
              </v-layout>
              <v-layout v-if="buttonlist == 1">
                <!-- table -->
                <v-flex xs12 class="scroll-able">
                  <table>
                    <thead>
                      <tr>
                        <th
                          nowrap
                          class="text-left topic-color"
                          width="5%"
                          rowspan="2"
                        >
                          ลำดับที่
                        </th>
                        <th
                          nowrap
                          class="text-lef topic-color"
                          width="20%"
                          rowspan="2"
                        >
                          เลขประจำตัวผู้เสียภาษีอากร
                        </th>
                        <th
                          nowrap
                          class="text-left topic-color"
                          width="30%"
                          rowspan="2"
                        >
                          ชื่อผู้มีเงินได้
                        </th>
                        <th
                          nowrap
                          class="text-left topic-color"
                          width="25%"
                          colspan="2"
                        >
                          รายละเอียดเกี่ยวกับการจ่ายเงิน
                        </th>
                        <th
                          nowrap
                          class="text-left topic-color"
                          width="20%"
                          rowspan="2"
                        >
                          จำนวนเงินภาษีที่นำส่ง
                        </th>
                      </tr>
                      <tr>
                        <th nowrap class="text-left topic-color">
                          วัน เดือน ปี ที่จ่าย
                        </th>
                        <th nowrap class="text-left topic-color">
                          จำนวนเงินได้ที่จ่าย
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, i) in newjson.details"
                        :key="i"
                        style="text-align: center"
                      >
                        <td>{{ i + 1 }}</td>
                        <td style="column-height: 100px">{{ item.id_card }}</td>
                        <td>{{ item.emp_name }}</td>
                        <td>{{ selectedformatDates(item.payDate) }}</td>
                        <td>{{ formatNumber(item.earning) }}</td>
                        <td>{{ formatNumber(item.tax_pay) }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr style="text-align: center">
                        <td colspan="4">รวมยอดเงินได้และภาษีนำส่งทั้งหมด</td>
                        <td>{{ formatNumber(newjson.total_earning) }}</td>
                        <td colspan="2">
                          {{ formatNumber(newjson.total_tax) }}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </v-flex>
              </v-layout>
            </v-layout>
            <!-- แสดงเงินเดือนและภาษีรวมทั้งหมด  -->
            <v-layout
              row
              wrap
              style="margin-top: 10px"
              v-if="newjson.details.length > 0"
            >
              <v-flex lg6 sm6 md6 xs12></v-flex>
              <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
                <span style="font-size: 16px">
                  {{ $t("Totallist") + " : " }}&nbsp;&nbsp;{{
                    newjson.details.length
                  }}&nbsp;&nbsp; {{ $t("List") }}</span
                >
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              style="margin-top: 5px"
              v-if="newjson.details.length > 0"
            >
              <v-flex lg6 sm6 md6 xs12></v-flex>
              <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
                <span style="font-size: 16px">
                  {{ $t("Totalsalary") + " : " }}&nbsp;&nbsp;
                  <span class="text-salary">{{
                    formatNumber(newjson.total_earning)
                  }}</span>
                  &nbsp;{{ $t("baht") }}
                </span>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              style="margin-top: 5px"
              v-if="newjson.details.length > 0"
            >
              <v-flex lg6 sm6 md6 xs12></v-flex>
              <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
                <span style="font-size: 16px">
                  {{ $t("Totaltax") + " : " }}&nbsp;&nbsp;
                  <span class="text-tax">{{
                    formatNumber(newjson.total_tax)
                  }}</span>
                  &nbsp;{{ $t("baht") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      :timeout="3500"
      :top="'top'"
      :color="snackbarcolor"
    >
      {{ snackmsg }}
      <v-btn dark flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import Empimage from "../../components/getempimage.vue";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import numeral from "numeral";
import Utils from "@/utils/";
import { constants } from "crypto";
export default {
  data: () => ({
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    from_date: "",
    to_date: "",
    tabledata: false,
    branch: "",
    json: {},
    dev: "",
    branch_items: [],
    newjson: {},
    buttonlist: 0,
    snackbarcolor: "red",
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    pageActive: 1,
    totalPages: 0,
    newarrayemp: [],
    arraydetails: [],
  }),

  components: {
    DeleteDialog,
    Empimage,
  },
  computed: {
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols",
    ]),
    ...mapState("filter", [
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
    ]),
  },
  created: function () {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.from_date = this.selectedformatDate(firstDay);
    this.to_date = this.selectedformatDate(lastDay);
    this.commitSetToolbar({ patternTool: "0" });
    this.getProfileBranchList();
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    groupBy(array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    process() { 
      this.newjson.details = [];
      this.arraydetails = [];
      this.tabledata = false;
      this.json = {};
      console.log("from_date: ", this.from_date);
      console.log("to_date: ", this.to_date);
     
      if (this.from_date == "" || this.to_date == "") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกวันที่ ";
        this.snackbarcolor = "error";
      }else {
        this.commitSetShowLoading(false);
        let v = this;
        DocumentService.getTaxDetailByMonths(
          this.branch,
          this.dev,
          this.from_date,
          this.to_date
        )
          .then((res) => {
            console.log(res);
            this.json = res.data;

            console.log("json: ", this.json);
              this.tabledata = true;
            //**new array **//
            this.newjson.from_date = this.json.from_date;
            this.newjson.to_date = this.json.to_date;
            this.newjson.total_earning = this.json.total_earning;
            this.newjson.total_tax = this.json.total_tax;

            var sumearning = 0;
            var sumtax_pay = 0;

            const unique = this.groupBy(this.json.details, "emp_code");
            console.log(unique);
            let keys = "";
            let index = 0;
            for (var key in unique) {
              console.log("key: ", key);
              let emp_code = "";
              let id_card = "";
              let emp_name = "";
              let payDate = "";
              let j = 0;
              sumearning = 0;
              sumtax_pay = 0;
              unique[key].forEach((element) => {
                emp_code = element.emp_code;
                id_card = element.id_card;
                emp_name = element.emp_name;
                payDate = element.payDate;
                sumearning += element.earning;
                sumtax_pay += element.tax_pay;
                j++;
              });
              this.newjson.details.push({
                emp_code: emp_code,
                id_card: id_card,
                emp_name: emp_name,
                payDate: payDate,
                earning: sumearning,
                tax_pay: sumtax_pay,
              });
            }
            console.log("json: ", this.json);
            console.log("new json: ", this.newjson);
            this.totalPages = this.newjson.details.length;
            this.checkbutton(0, "display");

            var array = [];
            this.newarrayemp = [];
            var k = 0;
            var i = 1;
            for (k = 0; k < this.newjson.details.length; k++) {
              console.log("k", this.newjson.details[k]);
              if (i <= 5) {
                array.push(this.newjson.details[k]);
                console.log("num: " + i);
              }
              if (i > 5) {
                this.newarrayemp.push(array);
                i = 1;
                array = [];
                array.push(this.newjson.details[k]);
                console.log("iii", this.newarrayemp);
                //this.perPage = i;
              }
              if (k == this.newjson.details.length - 1) {
                this.newarrayemp.push(array);
                console.log("ffff", this.newarrayemp);
              }
              i = i + 1;
            }
            console.log("newarrayemp: ", this.newarrayemp);
            this.totalPages = this.newarrayemp.length;
            /*close set data pagination*/
            for (var i = 0; i < this.newarrayemp.length; i++) {
              if (0 == i) {
                this.newarrayemp[i].forEach((element) => {
                  console.log("element: ", element);
                  this.arraydetails.push(element);
                });
              }
            }
            console.log("arraydetails: ", this.arraydetails);
          })
          .catch((err) => {
            console.log(err);
            0;
          });
      }
    },
    getdataList(pageOfItems) {
      this.arraydetails = [];
      for (var i = 0; i < this.newarrayemp.length; i++) {
        console.log("i: ", i);
        if (pageOfItems - 1 == i) {
          console.log("pageOfItems: ", pageOfItems - 1);
          this.newarrayemp[i].forEach((element) => {
            console.log("element: ", element);
            this.arraydetails.push(element);
          });
        }
      }
      console.log("arraydetails: ", this.arraydetails);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    thousandSep(nStr) {
      //nStr = nStr.toFixed(4);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          console.log(res);
          if (res.data.content.length > 0) {
            this.branch_items = res.data.content;
            console.log("eeee", this.branch_items);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewpdf() {
      if (this.branch == "") {
        window.open(
          "#/WHT/" + "ALL/" + this.from_date + "/" + this.to_date,
          "_blank"
        );
      } else {
        window.open(
          "#/WHT/" + this.branch + "/" + this.from_date + "/" + this.to_date,
          "_blank"
        );
      }
    },
    viewAttach1() {
      if (this.branch == "") {
        window.open(
          "#/Attach1/" + "ALL/" + this.from_date + "/" + this.to_date,
          "_blank"
        );
      } else {
        window.open(
          "#/Attach1/" +
            this.branch +
            "/" +
            this.from_date +
            "/" +
            this.to_date,
          "_blank"
        );
      }
    },
    checkbutton(buttonlist, type) {
      if (buttonlist == 1 && type == "display") {
        this.buttonlist = 1;
        console.log("table");
      } else if (buttonlist == 0 && type == "display") {
        this.buttonlist = 0;
        console.log("list");
        console.log("buttonlist", this.buttonlist);
      }
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    selectedformatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatNumber(val) {
      var result = numeral(val).format("0,0.00");
      return result;
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
#img_container {
  width: 500px;
  display: table-cell;
  vertical-align: middle;
}
#img_container img {
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  margin-bottom: 20px;
  display: block;
}
table,
td,
th {
  border: 1px solid black;
  height: 40px;
  font-size: 16px;
}
.topic-color {
  background-color: #1976d2;
  color: #ffff;
}
.v-card_text {
  padding: 20px 20px 20px 25px !important;
  width: 100%;
}
.text-tax {
  color: red;
  font-weight: 400;
  padding-left: 1px;
}
.text-salary {
  color: green;
  font-weight: 400;
  padding-left: 1px;
}
</style>
